import produce from 'immer';
import { v4 as uuid } from 'uuid';
import { SET_DOCUMENTS, SET_UPLOADED_FILES, DELETE_UPLOADED_FILE } from './actions';
import { validateFile } from '@shared/lib/file-upload';
const initialState = {};
function passengersReducer(state = initialState, { type, payload }) {
    return produce(state, draft => {
        switch (type) {
            case SET_DOCUMENTS: {
                Object.assign(draft, payload);
                break;
            }
            case SET_UPLOADED_FILES: {
                const { passengerId, files } = payload;
                const prevFiles = draft[passengerId] || [];
                /** добавляем файлам уникальный id и ваилидируем */
                const newFiles = files.map(file => ({
                    id: uuid(),
                    file,
                    error: validateFile(file)
                }));
                draft[passengerId] = [...prevFiles, ...newFiles];
                break;
            }
            case DELETE_UPLOADED_FILE: {
                const { passengerId, fileId } = payload;
                const prevFiles = draft[passengerId];
                draft[passengerId] = prevFiles.filter(file => file.id !== fileId);
                break;
            }
        }
    });
}
export default passengersReducer;
